import { render, staticRenderFns } from "./InputMoney.vue?vue&type=template&id=60b9be42"
import script from "./InputMoney.vue?vue&type=script&lang=js"
export * from "./InputMoney.vue?vue&type=script&lang=js"
import style0 from "./InputMoney.vue?vue&type=style&index=0&id=60b9be42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports